var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.appraisalExternal)?_c('AppraisalExternal'):_vm._e(),(_vm.appraisalInternal)?_c('AppraisalInternal'):_vm._e(),(_vm.access)?_c('h2',[_vm._v("No tiene permisos para crear tasaciones.")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }